module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring.a82322c.jpg";